'use strict';

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../contentDeliveryTypes'),
    TEAMSPACES = _require.TEAMSPACES,
    USER = _require.USER,
    FOLDER = _require.FOLDER;

var _require2 = require('../portalTypes'),
    SHARE = _require2.SHARE,
    SEND = _require2.SEND,
    SUBMIT = _require2.SUBMIT;

module.exports = (_module$exports = {}, _defineProperty(_module$exports, TEAMSPACES, SHARE), _defineProperty(_module$exports, USER, SEND), _defineProperty(_module$exports, FOLDER, SUBMIT), _module$exports);